/**
 * @fileoverview Legal-page chrome English (EN) bundle — AUTHORED here, the degrade path an unwired tree
 * renders, and the key set `es.js` must match leaf for leaf.
 * @package @puffin-core/legal-content
 *
 * Born JSDOC-PROP-CONTRACT-001 PACKAGE-I18N-SEAT U3 (2026-10-23), namespace #56: until then the package
 * carried NO catalog of its own — the CHROME around every legal document (the unavailable notice, the
 * table of contents, the effective-date label, the contact block's labels, the subprocessor rows' labels)
 * was English written into `LegalDocumentPage.jsx` and `SubprocessorList.jsx`, so a marketing site showing
 * Spanish chrome framed its documents in English labels. Every value is the English it rendered before
 * the move, byte for byte.
 *
 * 🔴 THE DOCUMENTS ARE NOT HERE, by design (owner-ruled): `registry/documents/**` is authored in English
 * only (`LEGAL_DOCUMENT_LANGUAGE`), and its words — section titles, paragraphs, a subprocessor's role,
 * categories, location and entity — render as written. Only the chrome a reader navigates by is worded
 * here.
 *
 * `chromeLanguage` is the BCP-47 tag of the language THIS bundle is written in. The components set it as
 * the `lang` of every element whose words come from this namespace (WCAG 3.1.2, Language of Parts), so a
 * Spanish label inside an English document is announced as Spanish — and, because it resolves exactly as
 * the words beside it do, the tag can never name a language the words are not in.
 *
 * Placeholders are `{{double}}` braces — the same syntax i18next interpolates when the namespace is
 * registered, so both resolution paths read one template.
 *
 * @module @puffin-core/legal-content/strings/en
 */

export const LEGAL_CONTENT_EN = Object.freeze({
  // The language these words are written in — the `lang` of every element worded from this bundle
  chromeLanguage: 'en',

  // The unavailable notice (`components/LegalDocumentPage.jsx`)
  unavailableTitle: 'Document unavailable',
  unavailableMessage:
    'This document is not available right now. Please contact us and we will provide it.',

  // The document's chrome (`components/LegalDocumentPage.jsx`)
  tableOfContents: 'Table of contents',
  effectiveDate: 'Effective Date: {{date}}',
  contactInformation: 'Contact information',
  contactEmail: 'Email:',

  // A subprocessor's row labels (`components/SubprocessorList.jsx`)
  subprocessorRole: 'Role',
  subprocessorDataCategories: 'Data categories',
  subprocessorLocation: 'Location',
  subprocessorLegalEntity: 'Legal entity',
  subprocessorReferences: 'References',
});

export default LEGAL_CONTENT_EN;
